export default __webpack_public_path__ + "static/media/question_fill.b4a3d763.svg";